<template>
	
		<el-dialog
		  :destroy-on-close='true'
		  ref='dialog'
		  :title="title"
		  :visible="dialogVisible"
		  :width="width"
		  @opened='opened'
		  @close="cancel"
		  :before-close="close">
		  <slot  name="default"></slot>
		</el-dialog>

		

		


</template>

<script>
	export default {

		props: {
			title: {
				type: String,
				default: '农资态势',
			},
			dialogVisible:{
				type:Boolean,
				default:false
			},
			width:{
				Type:String,
				default:'50%'
			}

		},
		data() {
			return {
				activeValue:'0',
				
			};
		},
		watch:{
			dialogVisible(n){
				console.log(n)
			}
		},
		async created() {
			
		},

		methods: {

			close(){
				this.$parent.$parent.dialogVisible=false

			},
			opened(){
				console.log(999)
				this.$emit('opened')
			},
			cancel(){
				this.$emit('cancel')
			}

		},
	};
</script>
<style lang="scss" scoped>
	
		::v-deep .el-dialog{
			background: url('../../../assets/yq/propertymodel.png');
			background-size: 100% 100%;
			box-shadow: 0px 0px 0.15rem 0px #00AEFF inset;
			
		}
		::v-deep .el-dialog__header{
			background: rgba(0,174,255,0.59);
			height: 0.48rem;
			padding: 0 0.25rem;
			position: relative;
		}
		::v-deep .el-dialog__title{
			color: #00FEFF;
			font-size: 0.23rem;
			font-family: Source Han Sans CN-Medium, Source Han Sans CN;
			font-weight: 500;
			line-height: 0.48rem;
		}
		::v-deep .el-dialog__headerbtn{
			top: 50%;
			transform: translateY(-50%);
			
		}
		::v-deep .el-dialog__close{
			color: #fff !important;
		}
		::v-deep .el-dialog__body{
			padding: 0;
		}
	 
</style>